/* Add to cart → − qty + stepper, sticky cart bar and fly-to-cart animation.
   Shared by the product page, collection cards and homepage sliders. */
(function () {
  if (window.customElements.get('cart-stepper')) return;

  /* free delivery thresholds, in cents of the cart currency.
     Comes from Theme settings → Free delivery; these are only the backup values (₸6,000 and ₹799). */
  var FREE_DELIVERY = { KZT: 600000, INR: 79900 };

  var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
  var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
  var updateUrl = (window.routes && window.routes.cart_update_url) || '/cart/update';
  var S = window.chitsStrings || {};

  var cartQty = null; /* variant id -> quantity in cart */
  var cartLoading = null;

  function renderAll() {
    document.querySelectorAll('cart-stepper').forEach(function (el) {
      if (el.render) el.render();
    });
  }

  function setFromCart(cart) {
    if (!cart || !cart.items) return;
    cartQty = {};
    cart.items.forEach(function (item) {
      cartQty[item.variant_id] = (cartQty[item.variant_id] || 0) + item.quantity;
    });
    renderAll();
    renderBar(cart);
  }

  /* ---------- money ---------- */
  function money(cents, currency) {
    var whole = cents % 100 === 0;
    try {
      return new Intl.NumberFormat('en', {
        style: 'currency',
        currency: currency || 'KZT',
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: whole ? 0 : 2,
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(whole ? 0 : 2) + ' ' + (currency || '');
    }
  }

  function thumb(url) {
    if (!url) return '';
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('width', '96');
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  /* ---------- sticky cart bar ---------- */
  var bar = null;

  function buildBar() {
    if (bar || document.body.classList.contains('template-cart')) return bar;
    bar = document.createElement('div');
    bar.className = 'cart-bar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', S.cartSummary || 'Cart summary');
    bar.innerHTML =
      '<div class="cart-bar__thumbs" aria-hidden="true"></div>' +
      '<div class="cart-bar__text"><b class="cart-bar__count"></b><span class="cart-bar__note"></span></div>' +
      '<a class="cart-bar__go" href="' + cartUrl + '">' + (S.viewCart || 'View cart') + '<span aria-hidden="true">→</span></a>' +
      '<span class="cart-bar__progress" aria-hidden="true"><span></span></span>';
    document.body.appendChild(bar);
    return bar;
  }

  function renderBar(cart) {
    if (!buildBar()) return;
    var count = cart.item_count || 0;

    if (!count) {
      bar.classList.remove('is-visible');
      document.body.classList.remove('has-cart-bar');
      return;
    }

    var thumbs = bar.querySelector('.cart-bar__thumbs');
    thumbs.innerHTML = '';
    cart.items.slice(0, 3).forEach(function (item) {
      if (!item.image) return;
      var img = document.createElement('img');
      img.src = thumb(item.image);
      img.alt = '';
      img.width = 48;
      img.height = 48;
      thumbs.appendChild(img);
    });

    bar.querySelector('.cart-bar__count').textContent =
      (S.items ? window.chitsPlural(S.items, count) : count + (count === 1 ? ' item' : ' items')) + ' · ' + money(cart.total_price, cart.currency);

    var note = bar.querySelector('.cart-bar__note');
    var fill = bar.querySelector('.cart-bar__progress span');
    var goal = S.freeDeliveryFrom != null ? S.freeDeliveryFrom : FREE_DELIVERY[cart.currency];
    if (goal) {
      var left = goal - cart.total_price;
      if (left > 0) {
        note.innerHTML = S.moreForFree ? S.moreForFree.replace('[amount]', money(left, cart.currency)) : '<strong>' + money(left, cart.currency) + '</strong> more for free delivery';
        bar.classList.remove('is-free');
      } else {
        note.textContent = S.freeUnlocked || 'Free delivery unlocked 🎉';
        bar.classList.add('is-free');
      }
      fill.style.width = Math.min(100, Math.round((cart.total_price / goal) * 100)) + '%';
      bar.classList.remove('no-goal');
    } else {
      note.textContent = '';
      bar.classList.add('no-goal');
    }

    if (!bar.classList.contains('is-visible')) {
      /* slides up the first time it appears after an add; appears instantly on page load */
      if (!bar.dataset.shown && !cartReadyForAnimation) bar.classList.add('no-anim');
      bar.dataset.shown = '1';
      requestAnimationFrame(function () {
        bar.classList.add('is-visible');
        document.body.classList.add('has-cart-bar');
        setTimeout(function () {
          bar.classList.remove('no-anim');
        }, 50);
      });
    }
  }

  var cartReadyForAnimation = false;

  function pulseBar() {
    if (!bar || !bar.classList.contains('is-visible')) return;
    bar.classList.remove('is-pulse');
    void bar.offsetWidth;
    bar.classList.add('is-pulse');
  }

  /* ---------- fly-to-cart ---------- */
  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function findProductImage(from) {
    var scope =
      from.closest('.quick-add-modal__content') ||
      from.closest('product-info') ||
      from.closest('.card-wrapper') ||
      from.closest('.product-card') ||
      from.closest('article') ||
      from.closest('li');
    if (!scope) return null;
    var img =
      scope.querySelector('.product__media-item.is-active img') ||
      scope.querySelector('.product__media img') ||
      scope.querySelector('.card__media img') ||
      scope.querySelector('.product-image-wrap img') ||
      scope.querySelector('img');
    if (!img) return null;
    var r = img.getBoundingClientRect();
    return r.width > 0 && r.bottom > 0 && r.top < window.innerHeight ? img : null;
  }

  function cartTarget() {
    var link = document.getElementById('cart-icon-bubble');
    if (!link) return null;
    var icon = link.querySelector('.svg-wrapper') || link;
    var r = icon.getBoundingClientRect();
    if (!r.width || r.bottom < 0 || r.top > window.innerHeight) return null;
    return r;
  }

  function flyToCart(img) {
    return new Promise(function (resolve) {
      var t = cartTarget();
      if (!img || !t || reducedMotion() || !document.body.animate) {
        resolve();
        return;
      }
      var s = img.getBoundingClientRect();
      var size = Math.round(Math.min(s.width, s.height, window.innerWidth < 750 ? 84 : 110));
      var sx = s.left + s.width / 2 - size / 2;
      var sy = s.top + s.height / 2 - size / 2;
      var dx = t.left + t.width / 2 - size / 2 - sx;
      var dy = t.top + t.height / 2 - size / 2 - sy;

      var outer = document.createElement('div');
      outer.className = 'cart-fly';
      outer.style.left = sx + 'px';
      outer.style.top = sy + 'px';
      outer.style.width = size + 'px';
      outer.style.height = size + 'px';
      var inner = document.createElement('img');
      inner.src = img.currentSrc || img.src;
      inner.alt = '';
      outer.appendChild(inner);
      document.body.appendChild(outer);

      var duration = window.innerWidth < 750 ? 650 : 750;
      /* sideways and upwards use different easing, which gives the curved path */
      outer.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(' + dx + 'px)' }], {
        duration: duration,
        easing: 'cubic-bezier(0.55, 0, 0.9, 0.45)',
        fill: 'forwards',
      });
      var anim = inner.animate(
        [
          { transform: 'translateY(0) scale(1)', opacity: 1 },
          { transform: 'translateY(' + dy * 0.6 + 'px) scale(0.7)', opacity: 1, offset: 0.6 },
          { transform: 'translateY(' + dy + 'px) scale(0.2)', opacity: 0.5 },
        ],
        { duration: duration, easing: 'cubic-bezier(0.2, 0.6, 0.35, 1)', fill: 'forwards' }
      );
      var finished = false;
      function end() {
        if (finished) return;
        finished = true;
        outer.remove();
        resolve();
      }
      anim.onfinish = end;
      setTimeout(end, duration + 200);
    });
  }

  function bumpCartIcon() {
    var link = document.getElementById('cart-icon-bubble');
    if (!link) return;
    link.classList.remove('cart-bump');
    void link.offsetWidth;
    link.classList.add('cart-bump');
    setTimeout(function () {
      link.classList.remove('cart-bump');
    }, 700);
  }

  function loadCart(force) {
    if (cartLoading && !force) return cartLoading;
    cartLoading = fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        setFromCart(cart);
        return cart;
      })
      .catch(function () {
        return null;
      });
    return cartLoading;
  }

  function qtyOf(id) {
    return (cartQty && cartQty[id]) || 0;
  }

  function sectionHTML(html, selector) {
    if (!html) return null;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector || '.shopify-section');
    return el ? el.innerHTML : null;
  }

  function updateBubble(sections) {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || !sections || !sections['cart-icon-bubble']) return;
    var inner = sectionHTML(sections['cart-icon-bubble']);
    if (inner !== null) bubble.innerHTML = inner;
  }

  function announce(cartData, variantId) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-stepper', productVariantId: variantId, cartData: cartData });
    }
  }

  class CartStepper extends HTMLElement {
    connectedCallback() {
      if (this._ready) {
        this.render();
        return;
      }
      this._ready = true;
      this.pending = null;
      this.seq = 0;

      this.addBtn = this.querySelector('[data-stepper-add]');
      this.controls = this.querySelector('[data-stepper-controls]');
      this.minusBtn = this.querySelector('[data-stepper-minus]');
      this.plusBtn = this.querySelector('[data-stepper-plus]');
      this.qtyEl = this.querySelector('[data-stepper-qty]');
      this.noteEl = this.querySelector('[data-stepper-note]');

      /* product page: follow the product form (variant changes + sold out state) */
      if (this.dataset.form) {
        this.form = document.getElementById(this.dataset.form);
        if (this.form) {
          this.idInput = this.form.querySelector('input[name="id"]');
          this.submitBtn = this.form.querySelector('[name="add"]');
          if (this.idInput) {
            this.idInput.addEventListener('change', () => {
              this.pending = null;
              this.render();
            });
          }
          if (this.submitBtn) {
            new MutationObserver(() => this.render()).observe(this.submitBtn, {
              attributes: true,
              attributeFilter: ['disabled'],
            });
          }
        }
      }

      this.addBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.add();
      });
      this.plusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.step(1);
      });
      this.minusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.step(-1);
      });

      this.render();
      loadCart().then(() => this.render());
    }

    get variantId() {
      if (this.idInput) return this.idInput.value ? Number(this.idInput.value) : null;
      return Number(this.dataset.variantId) || null;
    }

    get max() {
      /* product page: stock per variant, so + stops at what's left */
      if (this.form) {
        if (this.stock === undefined) {
          try {
            this.stock = JSON.parse(this.dataset.stock || '{}');
          } catch (e) {
            this.stock = {};
          }
        }
        var s = this.stock[this.variantId];
        return typeof s === 'number' ? Math.max(s, 0) : null;
      }
      var m = parseInt(this.dataset.max, 10);
      return isNaN(m) ? null : Math.max(m, 0);
    }

    get soldOut() {
      if (this.submitBtn) return this.submitBtn.hasAttribute('disabled') || !this.variantId;
      return this.hasAttribute('data-sold-out');
    }

    currentQty() {
      return this.pending !== null ? this.pending : qtyOf(this.variantId);
    }

    render() {
      if (!this.addBtn) return;
      var q = this.currentQty();
      var max = this.max;

      if (q > 0) {
        this.addBtn.hidden = true;
        this.controls.hidden = false;
        this.qtyEl.textContent = q;
        this.plusBtn.disabled = this.soldOut || (max !== null && q >= max);
        this.minusBtn.disabled = false;
      } else {
        this.controls.hidden = true;
        this.addBtn.hidden = false;
        var soldOut = this.soldOut || (max !== null && max <= 0);
        this.addBtn.disabled = soldOut || this.busy;
        var label = soldOut ? this.dataset.labelSoldOut : this.dataset.labelAdd;
        if (soldOut && this.submitBtn) {
          var s = this.submitBtn.querySelector('span');
          if (s && s.textContent.trim()) label = s.textContent.trim();
        }
        if (this.addBtn.textContent.trim() !== label) this.addBtn.textContent = label;
      }
    }

    flash(text) {
      if (!this.noteEl) return;
      var original = S.inCart || 'in cart';
      this.classList.add('is-limit');
      this.noteEl.textContent = text;
      clearTimeout(this._flashT);
      this._flashT = setTimeout(() => {
        this.classList.remove('is-limit');
        this.noteEl.textContent = original;
      }, 1800);
    }

    /* first tap: add 1, fly the photo into the cart icon, show / update the cart bar.
       (+ and − never animate — they only update the numbers) */
    add() {
      var id = this.variantId;
      if (!id || this.busy || this.soldOut) return;
      this.busy = true;
      this.pending = 1;
      this.classList.add('is-busy');
      this.render();
      cartReadyForAnimation = true;

      var flight = flyToCart(findProductImage(this));

      /* inside the "Choose options" popup: close it once the photo has taken off */
      var modal = this.closest('quick-add-modal');
      if (modal && modal.hide) {
        setTimeout(function () {
          modal.hide(true);
        }, 120);
      }

      var request = fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: id, quantity: 1, sections: ['cart-icon-bubble'], sections_url: window.location.pathname }),
      }).then(function (r) {
        return r.json();
      });

      Promise.all([request, flight])
        .then((results) => {
          var res = results[0];
          if (res.status) {
            /* e.g. sold out a moment ago */
            this.pending = null;
            this.flashAdd(res.description || res.message);
            return loadCart(true);
          }
          if (!cartQty) cartQty = {};
          cartQty[id] = res.quantity || 1;
          this.pending = null;
          updateBubble(res.sections);
          bumpCartIcon();
          renderAll();
          announce(res, id);
          return loadCart(true).then(pulseBar);
        })
        .catch(() => {
          this.pending = null;
          loadCart(true);
        })
        .finally(() => {
          this.busy = false;
          this.classList.remove('is-busy');
          this.render();
        });
    }

    flashAdd(message) {
      if (!message) return;
      this.addBtn.title = message;
    }

    /* + / − : update the screen instantly, send the final number after a short pause */
    step(delta) {
      var id = this.variantId;
      if (!id) return;
      var target = Math.max(0, this.currentQty() + delta);
      var max = this.max;
      if (max !== null && target > max) {
        this.flash((S.max || 'Max') + ' ' + max);
        return;
      }
      this.pending = target;
      this.render();
      clearTimeout(this._sendT);
      this._sendT = setTimeout(() => this.send(id, target), 350);
    }

    send(id, target) {
      var mySeq = ++this.seq;
      var updates = {};
      updates[id] = target;
      this.classList.add('is-busy');

      fetch(updateUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ updates: updates, sections: ['cart-icon-bubble'], sections_url: window.location.pathname }),
      })
        .then(function (r) {
          return r.json();
        })
        .then((cart) => {
          if (mySeq !== this.seq) return;
          if (cart.status) {
            /* asked for more than we have in stock */
            this.pending = null;
            return loadCart(true).then(() => {
              this.flash((S.max || 'Max') + ' ' + qtyOf(id));
            });
          }
          this.pending = null;
          setFromCart(cart);
          updateBubble(cart.sections);
          var got = qtyOf(id);
          if (got < target) this.flash((S.max || 'Max') + ' ' + got);
          announce(cart, id);
        })
        .catch(() => {
          if (mySeq !== this.seq) return;
          this.pending = null;
          loadCart(true);
        })
        .finally(() => {
          if (mySeq === this.seq) this.classList.remove('is-busy');
          this.render();
        });
    }
  }

  window.customElements.define('cart-stepper', CartStepper);

  /* keep every stepper in sync when the cart changes somewhere else (cart page, popup, other forms) */
  function listen() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'cart-stepper') return;
        loadCart(true);
      });
    }
  }
  function start() {
    listen();
    loadCart();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* coming back with the browser Back button shows an old copy of the page — refresh the numbers */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) loadCart(true);
  });
})();
